import { useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';

import AdvancedHotkey from './component';

import { refreshAllStores } from '../../../store/seller/seller.actions';

export const messages = defineMessages({
  name: {
    description: 'update all stores hotkey',
    defaultMessage: 'Update Stores',
    id: 'ol95x6',
  },
});

export const hotkey = ['u'];
export const barcodeContent = '+GASY2RCD3JC8=';

const UpdateStoresHotkey = ({ children }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const onUpdate = useCallback(() => dispatch(refreshAllStores()), [dispatch]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
      isGlobal: true,
    }),
    [intl, onUpdate],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

UpdateStoresHotkey.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UpdateStoresHotkey;
